import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClapboardWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconClapboardWide"><Path d="M22 20H2V10.5H22V20Z" fill="currentColor"/><Path d="M6.75098 9H2V4H8.41797L6.75098 9Z" fill="currentColor"/><Path d="M14 9H8.33301L10 4H15.667L14 9Z" fill="currentColor"/><Path d="M22 9H15.582L17.249 4H22V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClapboardWide;
